import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

const getHeaders = () => ({
  "Content-Type": "application/json",
  "X-Api-Key": sessionStorage.getItem("q2p_token"),
});

export const beneficiaryTransactionsCreate = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsCreate",
  async (values, { rejectWithValue }) => {
    const { beneficiaryTxnData } = values;

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/transactions/beneficiary`,
        beneficiaryTxnData,
        {
          headers: getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      console.error("[beneficiaryTransactionsCreate] API failed:", {
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });

      return rejectWithValue({
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
    }
  },
);

export const beneficiaryTransactionsRecreate = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsRecreate",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/beneficiary/refactor`,
        {
          txn_id: Array.isArray(id) ? id : [id],
        },
        {
          headers: getHeaders(),
        },
      );

      return response.data?.status
        ? response.data
        : rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const beneficiaryTransactionsViewAll = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsViewAll",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      lifecycle_status,
      start_date,
      end_date,
      page_item_count,
      search_string,
      payment_method,
      beneficiary_account_id,
      distribution_lifecycle_status,
      amount,
      owner_account_id,
      confidential_transaction,
      category_id,
      txn_id,
      refactor,
      labels,
      additional_data,
      entityId,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/beneficiary`,
        {
          headers: getHeaders(),
          params: {
            page_no,
            page_size: page_item_count,
            lifecycle_status,
            distribution_lifecycle_status,
            start_date,
            end_date,
            search_string,
            payment_method,
            beneficiary_account_id,
            amount,
            owner_account_id,
            confidential_transaction:
              confidential_transaction === "Show only confidential"
                ? "Y"
                : confidential_transaction === "Hide confidential"
                  ? "N"
                  : undefined,
            category_id,
            txn_id,
            refactor,
            labels,
            additional_data,
            entityId,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const beneficiaryTransactionsAddLabel = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsAddLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/beneficiary/add_label`,
        {
          record_ids,
          labels,
        },
        {
          headers: getHeaders(),
        },
      );

      return response.data?.status
        ? response.data
        : rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const beneficiaryTransactionsRemoveLabel = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsRemoveLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/beneficiary/remove_label`,
        {
          record_ids,
          labels,
        },
        {
          headers: getHeaders(),
        },
      );

      return response.data?.status
        ? response.data
        : rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const beneficiaryTransactionsDetailsById = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsDetailsById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/beneficiary/${id}`,
        {
          headers: getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
    }
  },
);

export const beneficiaryTransactionsActionable = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsActionable",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      category_id,
      entityId,
      labels,
      txn_id,
      owner_account_id,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/beneficiary/actionable`,
        {
          headers: getHeaders(),
          params: {
            page_no: page_no ? page_no : undefined,
            page_size: page_size ? page_size : undefined,
            category_id: category_id !== undefined ? category_id : undefined,
            entity_id: entityId ? entityId : undefined,
            labels: labels,
            txn_id: txn_id,
            owner_account_id: owner_account_id,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const beneficiaryTransactionsApprove = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsApprove",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/beneficiary/approve`,
        {
          txn_id: Array.isArray(id) ? id : [id],
        },
        {
          headers: getHeaders(),
        },
      );

      return response.data?.status
        ? response.data
        : rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const beneficiaryTransactionsReject = createAsyncThunk(
  "beneficiaryTransactions/beneficiaryTransactionsReject",
  async ({ id, reason }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/beneficiary/reject`,
        {
          txn_id: Array.isArray(id) ? id : [id],
          reason,
        },
        {
          headers: getHeaders(),
        },
      );

      return response.data?.status
        ? response.data
        : rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const bulkTransactionDownloadSampleFile = createAsyncThunk(
  "beneficiaryTransactions/bulkTransactionDownloadSampleFile",
  async ({ category_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/sample_file.csv`,
        {
          headers: getHeaders(),
          params: {
            category_id,
          },
          responseType: "blob",
        },
      );
      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${category_id}_sample_file.csv`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      CommonToast({
        text: "Sample file downloaded successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);

        errorMessage =
          parsed?.error?.base ||
          parsed?.error?.message ||
          parsed?.message ||
          error.message;
      } catch (err) {
        errorMessage = error.message;
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const bulkTransactionUpload = createAsyncThunk(
  "beneficiaryTransactions/bulkTransactionUpload",
  async ({ statementPayload }, { rejectWithValue }) => {
    try {
      const payload = {
        uploaded_file_data: {
          id: statementPayload?.uploaded_file_data?.id,
          storage: "cache",
          metadata: {
            filename: statementPayload?.uploaded_file_data?.metadata?.filename,
            size: statementPayload?.uploaded_file_data?.metadata?.size,
            mime_type:
              statementPayload?.uploaded_file_data?.metadata?.mime_type,
          },
        },

        category_id: statementPayload?.category_id,
        category_name: statementPayload?.category_name,
      };
      sessionStorage.setItem("uploadTxnStatementData", JSON.stringify(payload));

      const response = await axiosInstance.post(
        `${baseUrl}/transactions/upload`,
        payload,
        {
          headers: getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      sessionStorage.setItem("data", JSON.stringify(error));
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const bulkTransactionsViewAll = createAsyncThunk(
  "beneficiaryTransactions/bulkTransactionsViewAll",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_item_count,
      currentStatus,
      initCategory,
      start_date,
      end_date,
      file_name,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/upload`,
        {
          headers: getHeaders(),
          params: {
            page_no: page_no,
            category_id: initCategory,
            page_size: page_item_count,
            file_status: currentStatus,
            from_date: start_date,
            to_date: end_date,
            file_name: file_name,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const bulkTransactionsDetailsById = createAsyncThunk(
  "beneficiaryTransactions/bulkTransactionsDetailsById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/${id}/upload`,
        {
          headers: getHeaders(),
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const ownerAccountsViewAll = createAsyncThunk(
  "beneficiaryTransactions/OwnerAccountViewAll",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      approval_status,
      categoryName,
      page_size,
      search_string,
      bank_name,
      sort_by_balance,
    } = values || {};

    try {
      const response = await axiosInstance.get(`${baseUrl}/accounts/owner`, {
        headers: getHeaders(),
        params: {
          "page_no": page_no,
          "page_size": page_size,
          "approval_status": approval_status,
          "category": categoryName,
          "search_string": search_string,
          "connected_banking": "Y",
          "bank_name": bank_name,
          "sort_by_balance[balance]": sort_by_balance
            ? sort_by_balance === "Low to high"
              ? "ascending"
              : "descending"
            : undefined,
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

const beneficiaryTransactionsSlice = createSlice({
  name: "beneficiaryTransactions",
  initialState: {
    storedPage: 1,
    toggle: false,
    beneficiaryTransactionAvailableLabels: [],

    beneficiaryTransactionsCreateData: null,
    beneficiaryTransactionsCreateLoading: false,
    beneficiaryTransactionsCreateError: null,

    beneficiaryTransactionsRecreateData: null,
    beneficiaryTransactionsRecreateLoading: false,
    beneficiaryTransactionsRecreateError: null,

    beneficiaryTransactionsViewAllData: null,
    beneficiaryTransactionsViewAllLoading: false,
    beneficiaryTransactionsViewAllError: null,

    beneficiaryTransactionsAddLabelData: null,
    beneficiaryTransactionsAddLabelLoading: false,
    beneficiaryTransactionsAddLabelError: null,

    beneficiaryTransactionsRemoveLabelData: null,
    beneficiaryTransactionsRemoveLabelLoading: false,
    beneficiaryTransactionsRemoveLabelError: null,

    beneficiaryTransactionsDetailsData: null,
    beneficiaryTransactionsDetailsLoading: false,
    beneficiaryTransactionsDetailsError: null,

    beneficiaryTransactionsActionableData: null,
    beneficiaryTransactionsActionableLoading: false,
    beneficiaryTransactionsActionableError: null,

    beneficiaryTransactionsApproveData: null,
    beneficiaryTransactionsApproveLoading: false,
    beneficiaryTransactionsApproveError: null,

    beneficiaryTransactionsRejectData: null,
    beneficiaryTransactionsRejectLoading: false,
    beneficiaryTransactionsRejectError: null,

    bulkTransactionSampleFile: null,
    bulkTransactionSampleFileLoading: false,
    bulkTransactionSampleFileError: null,

    bulkTransactionUpload: null,
    bulkTransactionUploadLoading: false,
    bulkTransactionUploadError: null,

    bulkTransactionsViewAllLoading: null,
    bulkTransactionsViewAllData: null,
    bulkTransactionsViewAllError: null,

    bulkTransactionsDetailsLoading: false,
    bulkTransactionsDetailsData: null,
    bulkTransactionsDetailsError: false,

    ownerAccountsViewAllData: null,
    ownerAccountsViewAllLoading: false,
    ownerAccountsViewAllError: null,
  },
  reducers: {
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },
    resetToggle: (state) => {
      state.toggle = false;
    },
    setAvailabelLabels: (state, action) => {
      state.beneficiaryTransactionAvailableLabels = action.payload;
    },
    resetBeneTransactionsApproval: (state) => {
      state.beneficiaryTransactionsApproveError = false;
      state.beneficiaryTransactionsApproveData = false;
      state.beneficiaryTransactionsApproveLoading = null;
    },
    resetBeneTransactionsReject: (state) => {
      state.beneficiaryTransactionsRejectError = false;
      state.beneficiaryTransactionsRejectData = false;
      state.beneficiaryTransactionsRejectLoading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(beneficiaryTransactionsCreate.pending, (state) => {
        state.beneficiaryTransactionsCreateLoading = true;
      })
      .addCase(beneficiaryTransactionsCreate.fulfilled, (state, action) => {
        state.beneficiaryTransactionsCreateLoading = false;
        state.beneficiaryTransactionsCreateData = action?.payload;
      })
      .addCase(beneficiaryTransactionsCreate.rejected, (state, action) => {
        if (action?.payload?.data?.errors) {
          sessionStorage.setItem(
            "beneficiaryTxnCreateErrors",
            JSON.stringify(action?.payload?.data?.errors),
          );
        } else {
          sessionStorage.setItem(
            "beneficiaryTxnCreateErrors",
            JSON.stringify(action?.payload?.data?.error),
          );
        }
        state.beneficiaryTransactionsCreateLoading = false;
        state.beneficiaryTransactionsCreateData = null;
        state.beneficiaryTransactionsCreateError = action?.payload;
      })
      .addCase(beneficiaryTransactionsRecreate.pending, (state) => {
        state.beneficiaryTransactionsRecreateLoading = true;
      })
      .addCase(beneficiaryTransactionsRecreate.fulfilled, (state, action) => {
        state.beneficiaryTransactionsRecreateLoading = false;
        state.beneficiaryTransactionsRecreateData = action?.payload;
      })
      .addCase(beneficiaryTransactionsRecreate.rejected, (state, action) => {
        state.beneficiaryTransactionsRecreateLoading = false;
        state.beneficiaryTransactionsRecreateData = null;
        state.beneficiaryTransactionsRecreateError = true;
      })
      .addCase(beneficiaryTransactionsViewAll.pending, (state, action) => {
        if (action?.payload?.summary?.available_labels) {
          state.beneficiaryTransactionAvailableLabels = [];
        }
        state.beneficiaryTransactionsViewAllLoading = true;
      })
      .addCase(beneficiaryTransactionsViewAll.fulfilled, (state, action) => {
        const availableLabels = action.payload?.summary?.available_labels;
        state.beneficiaryTransactionsViewAllLoading = false;
        state.beneficiaryTransactionsViewAllData = action.payload;
        state.beneficiaryTransactionsViewAllError = null;

        if (Array.isArray(availableLabels) && availableLabels.length > 0) {
          state.beneficiaryTransactionAvailableLabels = availableLabels;

          sessionStorage.setItem(
            "beneficiaryTxnLabels",
            JSON.stringify(availableLabels),
          );
        }
      })
      .addCase(beneficiaryTransactionsViewAll.rejected, (state, action) => {
        if (action?.payload?.summary?.available_labels) {
          state.beneficiaryTransactionAvailableLabels = [];
        }
        state.beneficiaryTransactionsViewAllError = true;
        state.beneficiaryTransactionsViewAllData = null;
        state.beneficiaryTransactionsViewAllLoading = false;
      })
      .addCase(beneficiaryTransactionsAddLabel.pending, (state) => {
        state.beneficiaryTransactionsAddLabelLoading = true;
        state.beneficiaryTransactionsAddLabelError = null;
      })
      .addCase(beneficiaryTransactionsAddLabel.fulfilled, (state, action) => {
        state.beneficiaryTransactionsAddLabelLoading = false;
        state.beneficiaryTransactionsAddLabelData = action.payload;
      })
      .addCase(beneficiaryTransactionsAddLabel.rejected, (state, action) => {
        state.beneficiaryTransactionsAddLabelLoading = false;
        state.beneficiaryTransactionsAddLabelData = null;
        state.beneficiaryTransactionsAddLabelError = action.payload || true;
      })
      .addCase(beneficiaryTransactionsRemoveLabel.pending, (state) => {
        state.beneficiaryTransactionsRemoveLabelLoading = true;
        state.beneficiaryTransactionsRemoveLabelError = null;
      })
      .addCase(
        beneficiaryTransactionsRemoveLabel.fulfilled,
        (state, action) => {
          state.beneficiaryTransactionsRemoveLabelLoading = false;
          state.beneficiaryTransactionsRemoveLabelData = action.payload;
        },
      )
      .addCase(beneficiaryTransactionsRemoveLabel.rejected, (state, action) => {
        state.beneficiaryTransactionsRemoveLabelLoading = false;
        state.beneficiaryTransactionsRemoveLabelData = null;
        state.beneficiaryTransactionsRemoveLabelError = action.payload || true;
      })
      .addCase(beneficiaryTransactionsDetailsById.pending, (state, action) => {
        state.beneficiaryTransactionsDetailsLoading = true;
      })
      .addCase(
        beneficiaryTransactionsDetailsById.fulfilled,
        (state, action) => {
          state.beneficiaryTransactionsDetailsLoading = false;
          state.beneficiaryTransactionsDetailsData = action.payload;
        },
      )
      .addCase(beneficiaryTransactionsDetailsById.rejected, (state, action) => {
        state.beneficiaryTransactionsDetailsLoading = false;
        state.beneficiaryTransactionsDetailsError = true;
      })
      .addCase(beneficiaryTransactionsActionable.pending, (state, action) => {
        state.beneficiaryTransactionsActionableLoading = true;
      })
      .addCase(beneficiaryTransactionsActionable.fulfilled, (state, action) => {
        state.beneficiaryTransactionsActionableLoading = false;
        state.beneficiaryTransactionsActionableData = action.payload;
      })
      .addCase(beneficiaryTransactionsActionable.rejected, (state, action) => {
        state.beneficiaryTransactionsActionableError = true;
        state.beneficiaryTransactionsActionableData = null;
      })
      .addCase(beneficiaryTransactionsApprove.pending, (state, action) => {
        state.beneficiaryTransactionsApproveLoading = true;
      })
      .addCase(beneficiaryTransactionsApprove.fulfilled, (state, action) => {
        state.beneficiaryTransactionsApproveLoading = false;
        state.beneficiaryTransactionsApproveData = action.payload;
      })
      .addCase(beneficiaryTransactionsApprove.rejected, (state, action) => {
        sessionStorage.setItem(
          "beneficiaryTxnError",
          JSON.stringify(action.payload?.errors?.base),
        );
        state.beneficiaryTransactionsApproveError = true;
        state.beneficiaryTransactionsApproveData = null;
      })
      .addCase(beneficiaryTransactionsReject.pending, (state, action) => {
        state.beneficiaryTransactionsRejectLoading = true;
      })
      .addCase(beneficiaryTransactionsReject.fulfilled, (state, action) => {
        state.beneficiaryTransactionsRejectLoading = false;
        state.beneficiaryTransactionsRejectData = action.payload;
      })
      .addCase(beneficiaryTransactionsReject.rejected, (state, action) => {
        state.beneficiaryTransactionsRejectError = true;
        state.beneficiaryTransactionsRejectData = null;
        state.beneficiaryTransactionsRejectLoading = false;
        sessionStorage.setItem(
          "beneficiaryTxnError",
          JSON.stringify(action.payload?.errors?.base),
        );
      })
      .addCase(bulkTransactionDownloadSampleFile.pending, (state) => {
        state.bulkTransactionSampleFileLoading = true;
        state.bulkTransactionSampleFileError = null;
      })
      .addCase(bulkTransactionDownloadSampleFile.fulfilled, (state, action) => {
        state.bulkTransactionSampleFileLoading = false;
        state.bulkTransactionSampleFile = action.payload;
      })
      .addCase(bulkTransactionDownloadSampleFile.rejected, (state, action) => {
        state.bulkTransactionSampleFileLoading = false;
        state.bulkTransactionSampleFileError = action.payload;
      })
      .addCase(bulkTransactionUpload.pending, (state) => {
        state.bulkTransactionUploadLoading = true;
        state.bulkTransactionUploadError = null;
      })
      .addCase(bulkTransactionUpload.fulfilled, (state, action) => {
        state.bulkTransactionUploadLoading = false;
        state.bulkTransactionUpload = action.payload;
      })
      .addCase(bulkTransactionUpload.rejected, (state, action) => {
        state.bulkTransactionUploadLoading = false;
        state.bulkTransactionUpload = null;
        state.bulkTransactionUploadError = action.payload;
      })
      .addCase(bulkTransactionsViewAll.pending, (state) => {
        state.bulkTransactionsViewAllLoading = true;
      })
      .addCase(bulkTransactionsViewAll.fulfilled, (state, action) => {
        state.bulkTransactionsViewAllLoading = false;
        state.bulkTransactionsViewAllData = action?.payload;
      })
      .addCase(bulkTransactionsViewAll.rejected, (state, action) => {
        state.bulkTransactionsViewAllLoading = false;
        state.bulkTransactionsViewAllData = false;
        state.bulkTransactionsViewAllError = action?.payload;
      })
      .addCase(bulkTransactionsDetailsById.pending, (state, action) => {
        state.bulkTransactionsDetailsLoading = true;
      })
      .addCase(bulkTransactionsDetailsById.fulfilled, (state, action) => {
        state.bulkTransactionsDetailsLoading = false;
        state.bulkTransactionsDetailsData = action.payload;
      })
      .addCase(bulkTransactionsDetailsById.rejected, (state, action) => {
        state.bulkTransactionsDetailsError = true;
      })
      .addCase(ownerAccountsViewAll.pending, (state) => {
        state.ownerAccountsViewAllLoading = true;
      })
      .addCase(ownerAccountsViewAll.fulfilled, (state, action) => {
        state.ownerAccountsViewAllLoading = false;
        state.ownerAccountsViewAllData = action.payload;
      })
      .addCase(ownerAccountsViewAll.rejected, (state, action) => {
        state.ownerAccountsViewAllLoading = false;
        state.ownerAccountsViewAllError = action.payload;
      });
  },
});

export const {
  setToggle,
  resetToggle,
  resetBeneTransactionsApproval,
  resetBeneTransactionsReject,
} = beneficiaryTransactionsSlice.actions;

export default beneficiaryTransactionsSlice.reducer;
